import {Component, OnInit, ChangeDetectionStrategy} from "@angular/core";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {NzMessageService} from "ng-zorro-antd/message";
import {lastValueFrom} from "rxjs";
import {MetaDataDefinitionOptionDto, PTPMetaDataMapDto, PerFormaAPIService} from "src/app/services/pfapi.service";

@Component({
    selector: "app-ptp-metadata-map-edit",
    templateUrl: "./ptp-metadata-map-edit.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PTPMetaDataMapEditComponent implements OnInit {
    constructor(
        private readonly api: PerFormaAPIService,
        private route: ActivatedRoute,
        private router: Router,
        private message: NzMessageService,
        private fb: FormBuilder
    ) {}

    loading = true;
    isEditMode = false;
    mapId?: number;

    metaDataDefinitions: MetaDataDefinitionOptionDto[] = [];
    poFieldNames: string[] = [];

    form: FormGroup = this.fb.group({
        metaDataDefinitionID: [null as number | null, [Validators.required]],
        columnName: ["", [Validators.required]]
    });

    async ngOnInit() {
        try {
            const options = await lastValueFrom(this.api.getApiConfigurePtpMetadataMapsOptions());
            this.metaDataDefinitions = options.MetaDataDefinitions ?? [];
            this.poFieldNames = options.POFieldNames ?? [];
        } catch (e) {
            this.message.error("Failed to load form options");
            console.log(e);
        }

        const id = this.route.snapshot.queryParamMap.get("id");
        if (!id) {
            this.loading = false;
            return;
        }

        this.isEditMode = true;
        this.mapId = Number(id);

        try {
            const map = await lastValueFrom(this.api.getApiConfigurePtpMetadataMapsId(this.mapId));
            this.form.patchValue({
                metaDataDefinitionID: map.MetaDataDefinitionID,
                columnName: map.ColumnName
            });
        } catch (e) {
            this.message.error("Failed to load metadata map");
            console.log(e);
        } finally {
            this.loading = false;
        }
    }

    save = async () => {
        if (this.form.invalid) {
            Object.keys(this.form.controls).forEach(k => this.form.get(k)?.markAsTouched());
            return;
        }

        this.loading = true;

        const dto: PTPMetaDataMapDto = {
            PTPMetaDataMapID: this.mapId,
            MetaDataDefinitionID: this.form.value.metaDataDefinitionID,
            ColumnName: this.form.value.columnName
        };

        try {
            if (this.isEditMode) {
                await lastValueFrom(this.api.putApiConfigurePtpMetadataMaps(dto));
                this.message.success("Metadata map updated");
            } else {
                await lastValueFrom(this.api.postApiConfigurePtpMetadataMaps(dto));
                this.message.success("Metadata map created");
            }
            this.router.navigateByUrl("/configure/ptpmetadatamap");
        } catch (e) {
            this.message.error("Failed to save metadata map");
            console.log(e);
            this.loading = false;
        }
    };
}
